import React, { Fragment } from "react";
import LocalizationJSON from "../../localization/localization.json";
import { isMobile } from "react-device-detect";
import { LanguageContext } from "../../App";
import classes from "./FootBar.module.css";
import { AppHelper } from "../../App";
import AllLogos from "./AllLogos";

function FootBar(props) {
  const linkedin = "linkedin";

  return (
    <div className={classes.bar}>
      <div className={classes.logos}>
        <a
          href="https://www.linkedin.com/in/domi-federowicz/"
          className={classes.logo}
        >
          <AllLogos
            selectedlogo={"linkedinlogo"}
            width={25}
            height={25}
            fill="#7B858C"
          ></AllLogos>
        </a>
        <a
          href="https://instagram.com/domi.federowicz"
          className={classes.logo}
        >
          <AllLogos
            selectedlogo={"instagramlogo"}
            width={25}
            height={25}
            fill="#7B858C"
          ></AllLogos>
        </a>
      </div>

      <div className={classes.poweredby}>Site by scyzoryk.xyz</div>
    </div>
  );
}

export default FootBar;
